export const CaptainNotificationBannerSkeleton = () => {
	return (
		<div className="w-full relative py-4 px-4 sm:px-0">
			<div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-between items-center w-full rounded-xl border border-gray-200 bg-white p-4 animate-pulse">
				<div className="flex flex-col gap-3 w-full sm:w-auto">
					<div className="h-5 bg-gray-200 rounded-md w-full sm:w-[450px]" />

					<div className="flex gap-2">
						<div className="h-4 bg-gray-200 rounded-md w-32" />
						<div className="h-4 bg-gray-200 rounded-md w-24" />
					</div>

					<div className="flex items-center gap-2">
						<div className="size-2 bg-gray-200 rounded-full" />
						<div className="h-5 bg-gray-200 rounded-md w-56" />
					</div>
				</div>

				<div className="h-10 bg-gray-200 rounded-lg w-full sm:w-28" />
			</div>
		</div>
	);
};
